import { SummaryType, useSummaryStore } from "../stores/summaryStore";

// get stored summary data
export const useStoredSummary = (chatId: string, type: SummaryType) => {
  const getSummary = useSummaryStore((state) => state.getSummary);
  return getSummary(chatId, type);
};

// get stored summary data (both summary and snapshot)
export const useStoredSummaries = (chatId: string) => {
  const getSummary = useSummaryStore((state) => state.getSummary);
  return {
    summary: getSummary(chatId, "summary"),
    snapshot: getSummary(chatId, "snapshot"),
  };
};
